import { Page, useCurrent } from "./common";
import { PageHead } from "../components/ui";
import { Icon } from "../components/Icons";
import { useNavigate } from "react-router-dom";
import { useSession, useCan } from "../lib/auth";
import { TenderRoom } from "../components/TenderRoom";

/* The studio's view of tendering. Same room the client uses — they open the
   invitations, we run the process — plus the ability to rule a firm out. */
export default function Tendering() {
  const p = useCurrent();
  const me = useSession();
  const nav = useNavigate();
  const canEdit = useCan("reviews");
  if (!p) return null;
  const open = (p.tenders ?? []).filter((t) => !t.closedOn).length;

  return (
    <Page>
      <PageHead kicker={`${p.name} · Tendering`} title="Out to tender">
        {open > 0 && (
          <button className="btn ghost sm" onClick={() => nav(`/portal/${p.id}/tender`)}>
            <Icon.arrowUpRight width={15} />Client view
          </button>
        )}
      </PageHead>
      <TenderRoom p={p} who={me?.name ?? "Studio"} role={canEdit ? "studio" : "client"} />
    </Page>
  );
}
